import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAdminAuth } from './hooks/useAdminAuth';
import { AdminLayout } from './AdminLayout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { ComponentsListPage } from './pages/ComponentsListPage';
import { ComponentDetailPage } from './pages/ComponentDetailPage';
import { RfqListPage } from './pages/RfqListPage';
import { RfqDetailPage } from './pages/RfqDetailPage';
import { FluidsPage } from './pages/FluidsPage';
import { TemplatesPage } from './pages/TemplatesPage';
import { UsersPage } from './pages/UsersPage';
import { WorkspacePage } from './pages/WorkspacePage';
import { ToastProvider } from './components/Toast';

const LoadingScreen: React.FC = () => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    color: '#5f6368',
    fontSize: 14,
  }}>
    Loading...
  </div>
);

export const AdminApp: React.FC = () => {
  const { user, loading, error, login, logout } = useAdminAuth();

  if (loading) return <LoadingScreen />;

  if (!user) {
    return <LoginPage onLogin={login} error={error} />;
  }

  const displayName = user.email || user.username || 'Admin';

  return (
    <ToastProvider>
      <Routes>
        <Route element={<AdminLayout username={displayName} onLogout={logout} />}>
          <Route index element={<DashboardPage />} />
          <Route path="components" element={<ComponentsListPage />} />
          <Route path="components/:id" element={<ComponentDetailPage />} />
          <Route path="rfq" element={<RfqListPage />} />
          <Route path="rfq/:id" element={<RfqDetailPage />} />
          <Route path="fluids" element={<FluidsPage />} />
          <Route path="templates" element={<TemplatesPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="workspace" element={<WorkspacePage />} />
        </Route>
      </Routes>
    </ToastProvider>
  );
};
